<template>
  <div class="common-box admin-user-management">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="部门：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.departmentName"
                placeholder="请输入所属部门"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.phone"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.nickname"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="添加时间：">
              <el-date-picker
                v-model="form.createTimeBetween"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="handleSearchListData"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select size="mini" clearable v-model="form.status" @change="handleSearchListData">
                <el-option
                  v-for="item in statusArray"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['YHGLTJ']"
          class="plr28"
          @click="handleAdd"
        >添加</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['YHGLSC']"
          @click="deleteUserMore"
          class="plr28"
          plain
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['YHGLDC']"
          @click="exportUserList"
          class="plr28"
          plain
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="phone" label="登陆账号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="nickname" label="姓名" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="idCode" label="身份证号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="unitName" label="所属单位" width="150"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="departmentName"
            label="所属部门"
            width="150"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="roleListStr" label="角色" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="statusName" label="状态"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="202px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['YHGLBJ']"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <div class="btn-divide" v-if="hasRole['YHGLBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['YHGLSC']"
                type="text"
                @click="deleteUser(scope.row)"
              >删除</el-button>
              <div class="btn-divide" v-if="hasRole['YHGLSC']"></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['YHGLZT']"
                @click="handleType(scope.row)"
              >{{scope.row.status == 1 ? "禁用" : "激活"}}</el-button>
              <div class="btn-divide" v-if="hasRole['YHGLZT']"></div>
              <el-dropdown
                class="more-dropdown"
                size="mini"
                trigger="hover"
                v-if="hasRole['YHGLGD']"
                @command="e => handlerTableDropDown(e, scope.row)"
              >
                <el-button type="text" size="mini">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="refreshPassword">重置密码</el-dropdown-item>
                  <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
                  <el-dropdown-item command="taskAssigned">任务指派</el-dropdown-item>
                  <el-dropdown-item command="userWages">工资信息</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-user
      v-if="addUserVisible"
      @cancel="addUserVisible = false"
      @confirm="handleAddUserConfirm"
    ></add-user>
    <edit-user
      v-if="editUserVisible"
      :detail="userDetail"
      @cancel="editUserVisible = false"
      @confirm="handleEditUserConfirm"
    ></edit-user>
    <check-user v-if="checkUserVisible" :detail="userDetail" @cancel="checkUserVisible = false"></check-user>
    <change-password :userId="userId" v-if="showChagePassword" @cancel="showChagePassword = false"></change-password>
    <TaskAssigned :userId="userId" v-if="showTaskAssigned" @cancel="showTaskAssigned = false"/>
    <user-wages v-if="userWagesVisible" :detail="userDetail" @cancel="userWagesVisible = false"></user-wages>
  </div>
</template>

<script>
import {
  getUserList,
  deleteUser,
  exportUserList,
  restPassword,
  userChangeStatus,
} from "@/api/UserManagement";
import AddUser from "./components/AddUser";
import EditUser from "./components/EditUser";
import CheckUser from "./components/CheckUser";
import ChangePassword from "./components/ChangePassword";
import TaskAssigned from "./components/TaskAssigned";
import UserWages from "./components/UserWages";
export default {
  name: "UserManagement",
  components: {
    AddUser,
    EditUser,
    CheckUser,
    ChangePassword,
    TaskAssigned,
    UserWages
  },
  data() {
    return {
      form: {
        departmentId: "",
        nickname: "",
        phone: "",
        createTimeBetween: '',
        status: '',
        departmentName: ''
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addUserVisible: false,
      editUserVisible: false,
      checkUserVisible: false,
      userDetail: {},
      showChagePassword: false,
      showTaskAssigned: false,
      userWagesVisible: false,
      userId: "",
      statusArray: [
        { dictionaryValue: "激活", dictionaryCode: 1 },
        { dictionaryValue: "禁用", dictionaryCode: 2 },
      ],
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getUserList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSetUser(row) {},
    handleCheck(row) {
      this.userDetail = row;
      this.checkUserVisible = true;
    },
    handleEdit(row) {
      this.userDetail = row;
      this.editUserVisible = true;
    },
    handleAdd() {
      this.addUserVisible = true;
    },
    async exportUserList() {
      const params = await this.getParams();
      exportUserList(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddUserConfirm() {
      this.addUserVisible = false;
      this.getListData();
    },
    handleEditUserConfirm() {
      this.editUserVisible = false;
    },
    deleteUserMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的资源");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteUser({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteUser(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteUser({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlerTableDropDown(e, row) {
      if (e == "refreshPassword") {
        this.$confirm("是否确认将密码重置为电话号码?", "重置密码", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await restPassword({ userId: row.id });
            if (res.code === 200) {
              this.$message.success("重置成功");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (e == "changePassword"){
        this.userId = row.id;
        this.showChagePassword = true;
      } else if (e == "taskAssigned") {
        this.userId = row.id;
        this.showTaskAssigned = true;
      } else if (e == "userWages") {
        this.userDetail = row;
        this.userWagesVisible = true;
      }
    },
    handleType(row) {
      let message = "";
      if (row.status == 1) {
        message = "是否禁用？";
      } else {
        message = "是否激活？";
      }
      this.$confirm(message, "修改状态", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await userChangeStatus({
            idList: [row.id],
            status: row.status == 1 ? 2 : 1,
          });
          if (res.code === 200) {
            this.$message.success((row.status == 1 ? "禁用" : "激活") + "成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.admin-user-management {
  .checkbox-group-box {
    .el-form-item__content {
      width: 515px;
    }
  }
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/UserManagement.vue